const preview = "io.prismic.preview";
export {
  preview
};
